import gsap from "gsap";
class readMore {
  constructor() {
    this.init();
  }

  init() {
    const moreTexts = document.querySelectorAll('.js-load-more')
    if( moreTexts ) {
        moreTexts.forEach(moreText => {
          let shortText = moreText.querySelector('.js-load-trimmed');
          let fullText = moreText.querySelector('.js-load-full');
          if (shortText.querySelector('p')) {
            shortText.querySelector('p:last-child').appendChild( document.createTextNode( '\u00A0' ) );
          }
          gsap.set(fullText, {height: 0 });
          if (fullText) {
            if (shortText) {
              let more = document.createElement('button');
              more.innerHTML = shortText.getAttribute('data-label') ? shortText.getAttribute('data-label') : 'More';
              more.classList.add('js-more-button');
              more.classList.add('js-more-text');
              shortText.querySelector('p').appendChild(more);
              more.addEventListener('click', () => {
                gsap.to(shortText.querySelector('.js-more-text'), {autoAlpha: 0, duration: 0.1 });
                gsap.to(fullText, {height: 'auto', duration: 0.3, ease: 'power1.out' });
              });
            }
            let less = document.createElement('button');
            less.innerHTML = fullText.getAttribute('data-label') ? fullText.getAttribute('data-label') : 'Close';
            less.classList.add('js-more-button');
            less.classList.add('js-less-text');
            fullText.lastElementChild.appendChild(less);
            less.addEventListener('click', () => {
              gsap.to(shortText.querySelector('.js-more-text'), {autoAlpha: 1, duration: 0.1 });
              gsap.to(fullText, {height: 0, duration: 0.3, ease: 'power1.out' });
            });
          }
          
        });

    }
  }

}

export default readMore;